import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-freshwater-toolbar',
  templateUrl: './fresh-water-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule, MatButtonModule]
})
export class FreshwaterToolbarComponent {
  constructor(
    private _router: Router,
  ) { }

  addWater() {
    this._router.navigate(['vessels/fresh-water']).then();
  }
}
